<template>
    <div class="dropdown-content" id="myDropdown">
        <div style="display: flex; flex-direction: column; align-items: center;">
            <button @click="renewServiceModal()" class="display_block" v-if="details.itemData.isRenewable">
                {{$t('text.clickButtons.renewItem')}}
            </button>
            <button @click="recordServiceModal()" class="display_block" v-if="details.itemData.isServiceable">
                {{$t('text.clickButtons.recordService')}}
            </button>
            <button @click="changeActiveStatus()" class="display_block">
                {{(details.itemData.assetstatus == 4 || details.itemData.assetstatus == 7) ? 'Make Active' : 'Make In-active'}}
            </button>
            <button @click="addFile()" class="display_block">
                {{$t('text.clickButtons.addFile')}}
            </button>
            <router-link :to="{ name:'parent_assets', query: $route.query.branchId ? { id: details.itemData.parentId, branchId: $route.query.branchId } : { id: details.itemData.parentId }}" class="display_block" v-if="details.itemData.parentId">
                {{$t('text.clickButtons.parentAssets')}}
            </router-link>
            <button class="display_block" @click="deleteAsset">
                {{$t('text.actionButtons.delete')}}
            </button>
        </div>
    </div>
</template>

<script>

import configObject from "@/config";

export default {
    props: ['details'],
    created() {
    }, 
    methods: {
        renewServiceModal() {
            this.$eventHub.$emit('showCreateAssetModal', this.details.itemData.id, this.details.itemData.name)
        },
        recordServiceModal() {
            this.$eventHub.$emit('showRecordServiceModal', this.details.itemData.id)
        },
        addFile() {
            this.$eventHub.$emit('showAddFileModal', this.details.itemData.id)
        },
        changeActiveStatus() {
            let dialog = confirm(`Are you sure you want to make this asset ${(this.details.itemData.assetstatus == 4 || this.details.itemData.assetstatus == 7) ? 'active' : 'in-active'}. ${(this.details.itemData.assetstatus == 4 || this.details.itemData.assetstatus == 7) ? '' : 'Please note that the asset tracking and notification will cease.'}`)
            if(!dialog) {
                return;
            }
            const data = !this.details.itemData.isActive
            this.axios
                .put(
                `${configObject.apiBaseUrl}/Assets/${this.details.itemData.id}/change-active-status`,
                data,
                configObject.authConfig()
                )
                .then(() => {
                this.isButtonDisabled = true;
                this.$toast.open({
                    message: 'Successfully changed active status',
                    type: "success",
                    duration: 3000
                });

                $(".loader").hide();
                this.isButtonDisabled = false;
                this.$eventHub.$emit("refreshBranchAssets");
                })
                .catch((e) => {
                    this.$toast.open({
                        message: e.response.data.message,
                        type: "error",
                        duration: 3000
                    });
                    this.isButtonDisabled = false;
                    $(".loader").hide();
                });
        },
        deleteAsset() {
            let dialog = confirm("Are you sure you want to delete this asset")
            if(!dialog) {
                return;
            }
            this.axios
                .delete(
                `${configObject.apiBaseUrl}/Assets/${this.details.itemData.id}`,
                configObject.authConfig()
                )
                .then(() => {
                    this.$toast.open({
                        message: "Successfully deleted asset",
                        type: "success",
                        duration: 10000
                    });
                    this.$eventHub.$emit("refreshBranchAssets");
                })
                .catch(error => {
                    this.$toast.open({
                        message: error.response.data.message,
                        type: "error",
                        duration: 10000
                    });
                });
        }
    },
}
</script>

<style>

</style>